import {useEffect} from "react";
import {Form, InputNumber} from "antd";
import initLabelStyles from "./SettingsFormHelper";
import ResultHeader from "../Table/ResultHeader";
import ResultRow from "../Table/ResultRow";
import ResultHeaderCell from "../Table/ResultHeaderCell";
import ResultBody from "../Table/ResultBody";
import getSettingsItem from "./SettingsItem";
import ResultTable from "../Table/ResultTable";

export default function ({onValuesChange, values, defValues}) {

    return (
        <>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: 300}}>Variable</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left', width: 115}}>User Preference</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left', width: 115}}>System Default</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left', width: 230}}>Description</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {
                        getSettingsItem({
                            value: values?.delta_ws_gt,
                            defaultValue: defValues?.delta_ws_gt,
                            onChange: (value) => {onValuesChange('delta_ws_gt', value)},
                            label: 'Max Surcharge (ft)',
                            description: 'T-SRC-001'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.delta_ws_lt,
                            defaultValue: defValues?.delta_ws_lt,
                            onChange: (value) => {onValuesChange('delta_ws_lt', value)},
                            label: 'Min Surcharge (ft)',
                            description: 'T-SRC-001'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.skew_angle,
                            defaultValue: defValues?.skew_angle,
                            onChange: (value) => {onValuesChange('skew_angle', value)},
                            label: 'Max Skew Angle (degree)',
                            description: 'T-SKW-001, T-SKW-002'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.max_ob_channel,
                            defaultValue: defValues?.max_ob_channel,
                            onChange: (value) => {onValuesChange('max_ob_channel', value)},
                            label: 'Max OB to Channel DS Length Ratio',
                            description: 'DSRL-002, DSRL-003'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.max_dsrl,
                            defaultValue: defValues?.max_dsrl,
                            onChange: (value) => {onValuesChange('max_dsrl', value)},
                            label: 'Max DSRL (ft)',
                            description: 'T-XS-01'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.head_loss,
                            defaultValue: defValues?.head_loss,
                            onChange: (value) => {onValuesChange('head_loss', value)},
                            label: 'Head Loss (ft)',
                            description: 'HL-01'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.velocity_head,
                            defaultValue: defValues?.velocity_head,
                            onChange: (value) => {onValuesChange('velocity_head', value)},
                            label: 'Velocity Head Change (ft)',
                            description: 'VH-01'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.conv_ratio,
                            defaultValue: defValues?.conv_ratio,
                            onChange: (value) => {onValuesChange('conv_ratio', value)},
                            label: 'Conv. Ratio Range',
                            description: 'CR-01'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.transition_ratio_tol,
                            defaultValue: defValues?.transition_ratio_tol,
                            onChange: (value) => {onValuesChange('transition_ratio_tol', value)},
                            label: 'Transition Ratio Tol',
                            description: 'T-CES-01',
                            min: 0,
                            max: 1,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.dsrl_tol,
                            defaultValue: defValues?.dsrl_tol,
                            onChange: (value) => {onValuesChange('dsrl_tol', value)},
                            label: 'DSRL Tol (ft)',
                            description: 'T-SCRL-01',
                            min: 0,
                            max: 1,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.rs_diff,
                            defaultValue: defValues?.rs_diff,
                            onChange: (value) => {onValuesChange('rs_diff', value)},
                            label: 'RS Diff (ft)',
                            description: 'SCRS-01',
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.area_tol*100,
                            defaultValue: defValues?.area_tol*100,
                            onChange: (value) => {onValuesChange('area_tol', value/100)},
                            label: 'XS Topo Diff. Significance (%)',
                            description: 'SEC-02',
                            min: 0,
                            max: 100,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.structure_multiplier,
                            defaultValue: defValues?.structure_multiplier,
                            onChange: (value) => {onValuesChange('structure_multiplier', value)},
                            label: 'Structure Station Multiplier',
                            description: 'LB 07, LB 08',
                            min: 1,
                            max: 100,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.bs_slope,
                            defaultValue: defValues?.bs_slope,
                            onChange: (value) => {onValuesChange('bs_slope', value)},
                            label: 'Bank Station Slope',
                            description: 'XS 06',
                            min: -1,
                            max: 100,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.inv_slope_threshold,
                            defaultValue: defValues?.inv_slope_threshold || 0,
                            onChange: (value) => {onValuesChange('inv_slope_threshold', value)},
                            label: 'Invert Elevation Slope',
                            description: 'XS 05',
                            min: -1,
                            max: 100,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.drawdown_default,
                            defaultValue: defValues?.drawdown_default || 0,
                            onChange: (value) => {onValuesChange('drawdown_default', value)},
                            label: 'Drawdown',
                            description: 'OP 04',
                            min: 0,
                            max: 100,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.drawdown_slope_default,
                            defaultValue: defValues?.drawdown_slope_default?.toFixed(4) || 0,
                            onChange: (value) => {onValuesChange('drawdown_slope_default', value)},
                            label: 'Drawdown Slope',
                            description: 'OP 04',
                            min: -1,
                            max: 100,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.crossing_default,
                            defaultValue: defValues?.crossing_default || 0,
                            onChange: (value) => {onValuesChange('crossing_default', value)},
                            label: 'Crossing',
                            description: 'OP 03',
                            min: 0,
                            max: 100,
                        })
                    }

                    {
                        getSettingsItem({
                            value: values?.reach_average_dev,
                            defaultValue: defValues?.reach_average_dev || 0,
                            onChange: (value) => {onValuesChange('reach_average_dev', value)},
                            label: 'Channel Width Deviation from Reach Average (%)',
                            description: 'XS 08',
                            min: 0,
                            max: 100,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.bounding_average_dev,
                            defaultValue: defValues?.bounding_average_dev || 0,
                            onChange: (value) => {onValuesChange('bounding_average_dev', value)},
                            label: 'Channel Width Deviation from US/DS Average (%)',
                            description: 'XS 08',
                            min: 0,
                            max: 100,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.flow_change_rate,
                            defaultValue: defValues?.flow_change_rate || 0,
                            onChange: (value) => {onValuesChange('flow_change_rate', value)},
                            label: 'Flow Change Rate (%)',
                            description: 'FL 03',
                            min: 0,
                            max: 100,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.normal_depth_slope_max,
                            defaultValue: defValues?.normal_depth_slope_max || 0,
                            onChange: (value) => {onValuesChange('normal_depth_slope_max', value)},
                            label: 'Normal Depth Slope Max',
                            description: 'FL 07',
                            min: 0,
                            max: 100,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.normal_depth_slope_min,
                            defaultValue: defValues?.normal_depth_slope_min || 0,
                            onChange: (value) => {onValuesChange('normal_depth_slope_min', value)},
                            label: 'Normal Depth Min',
                            description: 'FL 07',
                            min: 0,
                            max: 100,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.inv_slope_threshold_max,
                            defaultValue: defValues?.inv_slope_threshold_max  || 0,
                            onChange: (value) => {onValuesChange('inv_slope_threshold_max', value)},
                            label: 'Invert Slope Max',
                            description: 'XS 05',
                            min: 0,
                            max: 100,
                        })
                    }
                </ResultBody>
            </ResultTable>
        </>
    )
}

const getRule = (message) => {
    return [{ required: true, message: message }]
}